// Homepage events (analytics sheet → "Homepage" section).
import {logAnalyticsEvent} from './analytics';
import {AnalyticsEntryPoint} from './events';
import type {TrackedItem, TrackedSection} from './shared';

const ENTRY_POINT = AnalyticsEntryPoint.Homepage;

export function trackHomepageViewAllClick(section: TrackedSection = {}) {
  logAnalyticsEvent('view_all_click', {
    entry_point: ENTRY_POINT,
    section_name: section.name,
    section_id: section.id,
  });
}

export function trackHomepageViewItemClick(item: TrackedItem, section: TrackedSection = {}) {
  logAnalyticsEvent('view_item_click', {
    entry_point: ENTRY_POINT,
    item_id: item.id,
    item_name: item.name,
    section_name: section.name,
    section_id: section.id,
  });
}

export function trackHomepageCardClick(item: TrackedItem, section: TrackedSection = {}) {
  logAnalyticsEvent('card_click', {
    entry_point: ENTRY_POINT,
    item_id: item.id,
    item_name: item.name,
    section_name: section.name,
    section_id: section.id,
  });
}

export function trackHomepageLearnMoreClick(section: TrackedSection = {}, item?: TrackedItem) {
  logAnalyticsEvent('learn_more_click', {
    entry_point: ENTRY_POINT,
    section_name: section.name,
    section_id: section.id,
    item_id: item?.id,
    item_name: item?.name,
  });
}

export function trackHomepageRegisterInterestClick(item?: TrackedItem, section: TrackedSection = {}) {
  logAnalyticsEvent('register_interest_click', {
    entry_point: ENTRY_POINT,
    item_id: item?.id,
    item_name: item?.name,
    section_name: section.name,
    section_id: section.id,
  });
}
